
import { useEffect, useState } from "react";
import { Cookies } from 'react-cookie';
import { post } from '../Common/service';
import { setFocus, setTitle } from '../Common/Common';
import Loader from '../Layout/Loader';
import { API_SERVER } from '../../EnvConfig/env_config';
import { AlertBox } from "../Common/Input";
import { useNavigate } from "react-router-dom";

const cookies = new Cookies();
const ChangePassword = ({ open, setOpen }) => {
    const [changePasswordData, setChangePasswordData] = useState({ oldPassword: '', newPassword: '', confirmPassword: '' })
    const [isLoading, setIsLoading] = useState(false);
    const [MenuText, setMenuText] = useState("Change Password");
    const navigate = useNavigate();
    const Token = cookies.get('token');
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const source = 'web'
    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = {
            Token,
            LoginUserCode,
            OldPassword: changePasswordData.oldPassword,
            NewPassword: changePasswordData.newPassword,
            ConfirmPassword: changePasswordData.confirmPassword,
            Source: source
        }
        setIsLoading(true);
        post(`${API_SERVER}/api/User/ChangePassword`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setIsLoading(false)
                AlertBox(res.status, res.message, res.focus);
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else {
                setIsLoading(false)
                AlertBox(res.status, res.message, res.focus);
            }
        })

    }

    const handleReset = () => {
        setChangePasswordData({ ...changePasswordData, newPassword: '', confirmPassword: '' })
    }

    useEffect(() => {
        setTitle('ChangePassword', setOpen);
        setFocus("txtOldPassword")
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, [])

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row">
                                    <div className="col-lg-4 col-md-6 col-sm-12" >
                                        <div className="fields">
                                            <label className="form-label">Old Password <span className="Required">*</span></label>
                                            <input
                                                id="txtOldPassword"
                                                type="password"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtNewPassword") };
                                                }}
                                                className={`form-control`}
                                                autoComplete="off"
                                                maxLength='15'
                                                minLength='8'
                                                placeholder='Old Password'
                                                name='oldPassword'
                                                value={changePasswordData.oldPassword}
                                                onChange={(e) => setChangePasswordData({ ...changePasswordData, oldPassword: e.target.value })}
                                            />
                                        </div>
                                        <div className="fields">
                                            <label className="form-label">New Password <span className="Required">*</span></label>
                                            <input
                                                id="txtNewPassword"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtConfirmPassword") };
                                                }}
                                                maxLength='15'
                                                minLength='8'
                                                type="password"
                                                placeholder='New Password'
                                                className="form-control"
                                                autoComplete="off"
                                                name='oldPassword'
                                                value={changePasswordData.newPassword}
                                                onChange={(e) => setChangePasswordData({ ...changePasswordData, newPassword: e.target.value })}
                                            />
                                        </div>
                                        <div className="fields">
                                            <label className="form-label">Confirm Password <span className="Required">*</span></label>
                                            <input
                                                id="txtConfirmPassword"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleSubmit(e);
                                                    };
                                                }
                                                }
                                                maxLength='15'
                                                minLength='8'
                                                type="password"
                                                className="form-control"
                                                placeholder='Confirm Password'
                                                autoComplete="off"
                                                name='oldPassword'
                                                value={changePasswordData.confirmPassword}
                                                onChange={(e) => setChangePasswordData({ ...changePasswordData, confirmPassword: e.target.value })}
                                            />
                                        </div>
                                        <div className="col-lg-12 mb-4">
                                            <div className="lms-new-button text-center">
                                                <button className="button save-btn" onClick={handleSubmit}>
                                                    <i className="bi bi-check-lg" /> Change Password
                                                </button>
                                                <button className="button reset-btn" onClick={handleReset}>
                                                    <i className="bi bi-arrow-clockwise" />Reset
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-8 col-md-8 col-sm-12'>
                                        <div className='password-policy-border'>
                                            <div className='w-100 py-2 password-policy px-3'>
                                                <h6 className="m-0 font-weight-bold text-white">{'Password Policy'}</h6>
                                            </div>
                                            <div className='p-4'>
                                                <div className="form-group px-2">
                                                    <li>White spaces are not allowed.</li>
                                                    <li>Password must be between 8 to 15 character(s).</li>
                                                    <li>Password must be combination of atleast one numeric and one upper case letter and Special character [@@$#!() ], white spaces are not allowed.</li>
                                                    <li>New password and confirm password must be same.</li>
                                                    <li>Old password and New password should be different.</li>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
        </main>
    )
}
export default ChangePassword;



